import {RouteInfo} from './sidebar.metadata';
import {ADMIN, SUPER_ADMIN} from '../../app.constants';

export const ROUTES: RouteInfo[] = [
  {
    path: '/partecipanti',
    title: 'Partecipanti',
    icon: 'icon-participants',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/corsi',
    title: 'Programmi',
    icon: 'icon-academy',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/sezioni',
    title: 'Corsi',
    icon: 'icon-sections',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/media-library',
    title: 'Media Library',
    icon: 'icon-video',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/quiz',
    title: 'Quiz',
    icon: 'icon-flag',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/news',
    title: 'News',
    icon: 'icon-news',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/ruoli',
    title: 'Ruoli',
    icon: 'icon-settings',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/farmacie',
    title: 'Farmacie',
    icon: 'icon-pin',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
  {
    path: '/user',
    title: 'Utenti',
    icon: 'icon-chat',
    class: '',
    badge: '',
    badgeClass: '',
    isExternalLink: false,
    submenu: [],
    permission: [ADMIN]
  },
];
